import { render, staticRenderFns } from "./InvoicesEnAttentePage.vue?vue&type=template&id=46b22aa2&scoped=true"
import script from "./InvoicesEnAttentePage.vue?vue&type=script&lang=js"
export * from "./InvoicesEnAttentePage.vue?vue&type=script&lang=js"
import style0 from "./InvoicesEnAttentePage.vue?vue&type=style&index=0&id=46b22aa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b22aa2",
  null
  
)

export default component.exports